import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TextBadge, useDeleteConfirmation } from '../common';
import { NXDelete, NXEditPen } from '../../icons';
import useApi from '../../api';
import GenericSelectableTable from '../selectableTable';
import enumChoice, { getEnumLabel } from '../../enum';


const ProductTable = ({ products, fetchProducts }: any) => {
    const { handleDelete } = useDeleteConfirmation();
    const api = useApi();

    const bullkActionButtons = [
        {
          label: 'Draft Selected',
          onClick: (selectedItems:any) => {
            const payload = {
                status: enumChoice.publishableStatus.toKV().DRAFT.value,
                product_ids: Array.from(selectedItems),
            }
            api.updateProductStatusBulk(payload).then((response) => {
                fetchProducts();
                toast.success("Product status updated successfully");
            }, (error) => {
                toast.error("Failed to update product status");
            })
          },
        },
        {
          label: 'Publish Selected',
          onClick: (selectedItems:any) => {
            const payload = {
                status: enumChoice.publishableStatus.toKV().PUBLISHED.value,
                product_ids: Array.from(selectedItems),
            }
            api.updateProductStatusBulk(payload).then((response) => {
                fetchProducts();
                toast.success("Product status updated successfully");
            }, (error) => {
                toast.error("Failed to update product status");
            })
          },
        },
        {
            label: 'Delete Selected',
            onClick: (selectedItems:any) => {
                const payload = {
                    product_ids: Array.from(selectedItems),
                }
               api.deleteProductBulk(payload).then((response) => {
                    fetchProducts();
                    toast.success("Product deleted successfully");
               }, (error) => {
                    toast.error("Failed to delete product");
               })
            },
        },
        {
            label: 'Archive Selected',
            onClick: (selectedItems:any) => {
                const payload = {
                    status: enumChoice.publishableStatus.toKV().ARCHIVED.value,
                    product_ids: Array.from(selectedItems),
                }
                api.updateProductStatusBulk(payload).then((response) => {
                    fetchProducts();
                    toast.success("Product status updated successfully");
                }, (error) => {
                    toast.error("Failed to update product status");
                })
            },
        },
    ];

    // Define columns with render functions for custom content
    const columns = [
        { header: "Name", key: "id", render: (item: any) => (
            <div className="flex flex-col space-y-1">
                <p className="text-lg font-semibold text-gray-800">{item.name}</p>
                <p className="text-sm text-gray-500">#{item.id}</p>
            </div>
        )},
        { header: "Category", key: "category" },
        {header: "Price", key: "product_price_range"},
        { header: "Status", key: "status", render: (item: any) => (
            <TextBadge value={item.status} label={getEnumLabel(enumChoice.publishableStatus, item.status)} />
        )},
        {header: 'Total Variant', key: 'total_variant'},
        // {header: 'Product Type', key: 'product_type'},
        { header: "Actions", key: "actions", render: (item: any) => (
            <div className="flex gap-2">
                <button className="p-1" onClick={() => handleDelete(item.id, 'Product', api.deleteProduct, fetchProducts)}>
                    <NXDelete />
                </button>
                <Link to={`../products/edit/${item.id}`} className="p-1">
                    <NXEditPen />
                </Link>
            </div>
        )}
    ];

    const printableColumn = [
        { header: "ID", key: "id" },
        { header: "Name", key: "name" },
        { header: "Category", key: "category" },
        { header: "Price", key: "product_price_range" },
        { header: "Status", key: "status" },
        { header: "Total Variant", key: "total_variant" },    
      ]

    return (
        <div className="relative overflow-x-auto px-1">
            <GenericSelectableTable printableColumn={printableColumn} columns={columns} data={products?.results || []} bullkActionButtons={bullkActionButtons} />
        </div>
    );
};

export default ProductTable;
